import * as actions from './../../actions'
import { getApiConfig } from './../../utilities';
import { newInstallationGroupActionTypes as NIGActionTypes } from './NewInstallationGroup/NewInstallationGroupActions';
import customEvent from "../../utilities/customEvent";

const {get, post} = getApiConfig('Installation/');

export const InstallationActionTypes = {
  DATA_LOADED: 'installation/data-loaded',
  SET_ACTIVE_GROUP: 'installation/set-active-group',
  SAVE_INSTALLATION: 'installation/save'
}

export function setActiveInstallationGroup(group) {
  return (dispatch) => {
    dispatch({
      type: InstallationActionTypes.SET_ACTIVE_GROUP,
      payload: group
    });
  }
}

export function saveInstallationItem(item) {
  return (dispatch) => {
    dispatch({
      type: InstallationActionTypes.SAVE_INSTALLATION,
      payload: item
    });
    document.dispatchEvent(customEvent('installation-item-saved'));
  }
}
